import { render, staticRenderFns } from "./PtoChange.vue?vue&type=template&id=56b0b23c&scoped=true"
import script from "./PtoChange.vue?vue&type=script&lang=js"
export * from "./PtoChange.vue?vue&type=script&lang=js"
import style0 from "./PtoChange.vue?vue&type=style&index=0&id=56b0b23c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b0b23c",
  null
  
)

export default component.exports